import React from 'react';
import { Helmet } from 'react-helmet';

const Profile = () => {
    return (
        <div>
            <Helmet>
      <title>Profile</title>
    </Helmet>
            <h1>User Profile</h1>
        </div>
    );
};

export default Profile;